import React from "react";
import { BsFillWalletFill, BsClockFill, BsTrophyFill } from "react-icons/bs";
import MarginBottom from "./MarginBottom";
const HTPCard = () => {
  return (
    <>
      <h2 className="text-3xl sm:text-4xl my-10 text-lyellow px-[2.3em] font-semibold text-center sm:text-left">How To Play</h2>
      <div className="flex flex-col justify-center items-center md:grid md:grid-cols-2 lg:grid-cols-3  px-[5em] pb-5">
        <div className="block p-6 max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md mb-10 cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <BsFillWalletFill className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            1. Buy Ticket
          </h5>
          <p className="font-normal text-white">
            You need to buy a ticket to play the lottery. You can buy a ticket
            using USDT.
          </p>
        </div>

        <div className="block p-6 md:py-[2.3rem]  max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md mb-10 cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <BsClockFill className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            2. Wait for the Draw
          </h5>
          <p className="font-normal text-white">
          There is one draw every friday at 00:00 UTC.
          </p>
        </div>

        <div className="block p-6 max-w-sm bg-black/40 rounded-2xl border border-black/80 shadow-md mb-10 cursor-pointer">
          <div className="w-full flex justify-center items-center">
            <BsTrophyFill className="inline-block h-12 w-12 text-lyellow mb-4" />
          </div>
          <h5 className="mb-2 text-lg font-bold tracking-tight text-lyellow">
            3. Check for Prizes
          </h5>
          <p className="font-normal text-white">
          Once the round’s over, come back to the page and check to see if you’ve won!
          </p>
        </div>
      </div>
    
      <MarginBottom />
    </>
  );
};

export default HTPCard;
